import { v2SaleContract } from "config";
import { BigNumber } from "ethers";
import { useContractRead } from "wagmi";

const useSaleHoneyReward = (): [
  honeyReward: BigNumber | undefined,
  readHoneyReward: () => void
] => {
  const [{ data: honeyRewardData }, readHoneyReward] = useContractRead(
    {
      addressOrName: v2SaleContract.address,
      contractInterface: v2SaleContract.interface,
    },
    "price"
  );

  if (honeyRewardData === undefined) {
    return [undefined, readHoneyReward];
  }

  return [honeyRewardData as any as BigNumber, readHoneyReward];
};

export default useSaleHoneyReward;
